module.exports = __webpack_public_path__ + "img/ambientes.95e698a8.svg";